import { ComponentRepeater } from "@/components/atoms/ComponentRepeater";
import { Skeleton } from "@/components/atoms/Skeleton";
import { ApplicationCardSkeleton } from "@/components/molecules/ApplicationCard";
import type { IApplicationsListSkeleton } from "@/components/molecules/ApplicationsList/types";

import { pageAndLimitDefaultValue } from "@/common/constants/common";

const ApplicationListSkeleton = ({
  showTitleAndDescription = true,
}: IApplicationsListSkeleton) => {
  return (
    <div className="flex flex-col gap-4">
      {showTitleAndDescription && (
        <div className="flex flex-col gap-1 max-sm:px-4">
          <Skeleton className="w-40 h-5 rounded-xl" />
          <Skeleton className="w-72 h-3 rounded-xl" />
        </div>
      )}

      <div className="grid grid-cols-4 max-sm:grid-cols-1 max-md:grid-cols-2 max-lg:grid-cols-1 max-xl:grid-cols-2 max-xxl:grid-cols-3 gap-4">
        <ComponentRepeater
          count={pageAndLimitDefaultValue.limit}
          component={<ApplicationCardSkeleton />}
        />
      </div>
    </div>
  );
};

export default ApplicationListSkeleton;
